import axios, { AxiosResponse } from "axios"
import { database, firebase } from "../../firebase";
import { dbFirestore } from "../../firebase";

export const GetLevelsAllowedByUser = async (
    userId: string,
    controller: AbortController
) => {
    const data = await axios.post<any, AxiosResponse<IGetLevelsAllowedByUserResponseBody, any>>(
        'https://getlevelsallowedbyuser-5kg2vejuqa-uc.a.run.app',
        {
            userId: userId
        },
        {
            signal: controller.signal
        });
    return data.data.levels;

}

export const CreateUserIfNoExistsAndActivateLevels = async (payload: {
    orderId: string;
    email: string;
    name: string;
    lastname: string;
}) => {
    const data = await axios.post<any, AxiosResponse<ICreateUserIfNoExistsAndActivateLevelsResponseBody, any>>(
        'https://createuserifnoexistsandactivatelevels-5kg2vejuqa-uc.a.run.app',
        {
            orderId: payload.orderId,
            email: payload.email,
            name: payload.name,
            lastname: payload.lastname
        });
    return data.data;
}

export const GetOrderSummary = async (
    payload: {
        publicId: string;
        code?: string;
    }
) => {
    const data = await axios.post<any, AxiosResponse<IGetOrderSummary, any>>(
        'https://getordersummary-5kg2vejuqa-uc.a.run.app',
        {
            publicId: payload.publicId,
            code: payload.code
        });
    return data.data;
}

export const ActivateCode = async (
    props: {
        userId: string;
        email: string;
        code: string;
    }
) => {
    return axios.post(
        'https://activatecode-5kg2vejuqa-uc.a.run.app',
        {
            userId: props.userId,
            email: props.email,
            code: props.code,
        },
    );
}


export const SetCompleted = async (props: {
    userId: string;
    episodeId: string;
    chapterId: string;
    lessonId: string;
}) => {
    await axios.post(
        'https://completelesson-5kg2vejuqa-uc.a.run.app',
        {
            userId: props.userId,
            episodeId: props.episodeId,
            chapterId: props.chapterId,
            lessonId: props.lessonId
        },
    );
}


export const SubscribeToEpisodesCompleted = (props: {
    userId: string;
    onGet: (episodeId: string) => void;
    onDelete: (episodeId: string) => void;
}) => {
    const ref = database.ref(`completed/${props.userId}/episodes`);

    const handleOnChildAdded = (snapshot: firebase.database.DataSnapshot) => {
        const episodeId = snapshot.key;
        const value = snapshot.val();
        if (episodeId === null) return;
        if (value === true) props.onGet(episodeId);
    }

    const handleOnChildChanged = (snapshot: firebase.database.DataSnapshot) => {
        const episodeId = snapshot.key;
        const value = snapshot.val();
        if (episodeId === null) return;
        if (value === true) props.onGet(episodeId);
        else props.onDelete(episodeId);
    }

    const handleOnChildRemoved = (snapshot: firebase.database.DataSnapshot) => {
        const episodeId = snapshot.key;
        if (episodeId === null) return;
        props.onDelete(episodeId);
    }

    ref.on("child_added", handleOnChildAdded);
    ref.on("child_changed", handleOnChildChanged);
    ref.on("child_removed", handleOnChildRemoved);

    return () => {
        ref.off("child_added", handleOnChildAdded);
        ref.off("child_changed", handleOnChildChanged);
        ref.off("child_removed", handleOnChildRemoved);
    };
}


export const SubscribeToChaptersCompleted = (props: {
    userId: string;
    episodeId: string;
    onGet: (chapterId: string) => void;
    onDelete: (chapterId: string) => void;
}) => {
    const ref = database.ref(`completed/${props.userId}/chapters/${props.episodeId}`);

    const handleOnChildAdded = (snapshot: firebase.database.DataSnapshot) => {
        const chapterId = snapshot.key;
        const value = snapshot.val();
        if (chapterId === null) return;
        if (value === true) props.onGet(chapterId);
    }

    const handleOnChildChanged = (snapshot: firebase.database.DataSnapshot) => {
        const chapterId = snapshot.key;
        const value = snapshot.val();
        if (chapterId === null) return;
        if (value === true) props.onGet(chapterId);
        else props.onDelete(chapterId);
    }

    const handleOnChildRemoved = (snapshot: firebase.database.DataSnapshot) => {
        const chapterId = snapshot.key;
        if (chapterId === null) return;
        props.onDelete(chapterId);
    }

    ref.on("child_added", handleOnChildAdded);
    ref.on("child_changed", handleOnChildChanged);
    ref.on("child_removed", handleOnChildRemoved);

    return () => {
        ref.off("child_added", handleOnChildAdded);
        ref.off("child_changed", handleOnChildChanged);
        ref.off("child_removed", handleOnChildRemoved);
    };
}


export const SubscribeToLessonsCompleted = (props: {
    userId: string;
    chapterId: string;
    onGet: (lessonId: string) => void;
    onDelete: (lessonId: string) => void;
}) => {
    const ref = database.ref(`completed/${props.userId}/lessons/${props.chapterId}`);

    const handleOnChildAdded = (snapshot: firebase.database.DataSnapshot) => {
        const lessonId = snapshot.key;
        const value = snapshot.val();
        if (lessonId === null) return;
        if (value === true) props.onGet(lessonId);
    }

    const handleOnChildChanged = (snapshot: firebase.database.DataSnapshot) => {
        const lessonId = snapshot.key;
        const value = snapshot.val();
        if (lessonId === null) return;
        if (value === true) props.onGet(lessonId);
        else props.onDelete(lessonId);
    }

    const handleOnChildRemoved = (snapshot: firebase.database.DataSnapshot) => {
        const lessonId = snapshot.key;
        if (lessonId === null) return;
        props.onDelete(lessonId);
    }

    ref.on("child_added", handleOnChildAdded);
    ref.on("child_changed", handleOnChildChanged);
    ref.on("child_removed", handleOnChildRemoved);

    return () => {
        ref.off("child_added", handleOnChildAdded);
        ref.off("child_changed", handleOnChildChanged);
        ref.off("child_removed", handleOnChildRemoved);
    };
}